import { render, staticRenderFns } from "./EditTokens.vue?vue&type=template&id=4e81ffa6&"
import script from "./EditTokens.vue?vue&type=script&lang=js&"
export * from "./EditTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports